"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _reactRedux = require("react-redux");

var _actions = require("../../../redux/locations/actions");

var _selectors = require("../../../redux/locations/selectors");

var _selectors2 = require("../../../redux/attributes/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MedicationSelect = function MedicationSelect(_ref) {
  var otherProps = _extends({}, _ref);

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      filter = _useSearchSelector.filter,
      lastSearchId = _useSearchSelector.lastSearchId;

  var medications = (0, _selectors2.useMedicationsAvailableSelector)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var medicationsFilter = filter.medicationsAvailable;
  var medicationsAvailableOptions = (0, _react.useMemo)(function () {
    if (medications) {
      var _process$env$REACT_AP;

      // These medication ids are filtered from the medication list for display
      var hiddenIds = (_process$env$REACT_AP = process.env.REACT_APP_HIDDEN_MEDICATION_IDS) === null || _process$env$REACT_AP === void 0 ? void 0 : _process$env$REACT_AP.split(",");
      console.log("hiddenIds", hiddenIds);
      return medications.filter(function (medication) {
        return hiddenIds ? !hiddenIds.includes(medication.key) : true;
      }).map(function (medication, index) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: "medication-" + index,
          value: JSON.stringify({
            key: medication.key,
            groupKey: medication.groupKey,
            label: medication.option.name,
            index: index
          })
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: !!medicationsFilter.find(function (med) {
            return med.key === medication.key;
          }) ? "locator-form-filter-selected" : ""
        }, medication.option.name));
      });
    }

    return null;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    name: "medication",
    style: {
      fontSize: "15px",
      fontFamily: "Lato",
      color: "#1c5c7f",
      lineHeight: "normal"
    },
    multiple: true,
    fullWidth: true,
    value: medicationsFilter.map(function (med) {
      return JSON.stringify(med);
    }),
    displayEmpty: true,
    renderValue: function renderValue(value) {
      var names = value.map(function (val) {
        return JSON.parse(val).label;
      }).join(", ");
      return value.length ? names : "Any medication";
    },
    onChange: function onChange(event) {
      var values = event.target.value.map(function (value) {
        return JSON.parse(value);
      });
      dispatch((0, _actions.updateMedicationFilter)(values, lastSearchId)); // TODO: Tracking
      // if (this.props.filter.medicationsAvailable.length || (values && values.length)) {
      //     Tracker.trackEvent(CATEGORY, "medication filter change", values.join(", "), "");
      // }
      //
      // api.trackMedicationFilter(null, {
      //     ...this.props.filter,
      //     medicationsAvailable: values,
      // }, this.state.medicationsAvailable);
    }
  }, otherProps), medicationsAvailableOptions);
};

var _default = MedicationSelect;
exports.default = _default;